import { ControlAttributeType, } from "../../../typings";
import { formatterValueToSetStatus, formatterRequiredFormula, formatterValueNoUp, } from "../../../utils";
import baseAttribute from "../../common/component-base-attribute";
import { FormControlType } from "../../../schema";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [
                "limit",
                "batch",
                "fileTypes",
                "displayTemplate",
                "templateFile",
                "dataLinkage"
            ],
        },
        scripts: {
            label: "控件事件",
            keys: ["onUpload", "onDelete"],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: {
            inputMethod: ControlAttributeType.Dropdown,
            value: FormControlType.Attachment,
            options: {
                // Todo 将控件编码 换成 说明文字, 创建所有组件的 编码说明文件
                list: [
                    {
                        value: FormControlType.Attachment,
                        label: i18n.t('dataitem.Attachment').toString(),
                    },
                    {
                        value: FormControlType.Image,
                        label: i18n.t('dataitem.Image').toString(),
                    },
                    {
                        value: FormControlType.Signature,
                        label: i18n.t('dataitem.Signature').toString(),
                    },
                ],
            },
        },
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.Attachment').toString() }),
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "requiredRule",
            inputComponent: () => import("../../common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
        dataLinkage: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../common/components/data-linkage2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        limit: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "1M",
                        label: "1M",
                    },
                    {
                        value: "5M",
                        label: "5M",
                    },
                    {
                        value: "10M",
                        label: "10M",
                    },
                    {
                        value: "20M",
                        label: "20M",
                    },
                    {
                        value: "50M",
                        label: "50M",
                    },
                    {
                        value: "100M",
                        label: "100M",
                    },
                    {
                        value: "200M",
                        label: "200M",
                    },
                ],
            },
        },
        fileTypes: {
            tip: {
                content: i18n.t('dataitem.FileTypeLimitTips').toString(),
                icon: "question-circle-o",
            },
            options: {
                regexps: {
                    maxLength: {
                        len: 200,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 200 }).toString(),
                    },
                },
            },
        },
        displayTemplate: {
            inputMethod: ControlAttributeType.Boolean,
            options: {
                hideField: (value) => {
                    // console.log(value, 'value');
                    if (!value) {
                        return ["templateFile"];
                    }
                    else {
                        return [];
                    }
                },
            },
        },
        templateFile: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../common/components/attachment-file.vue"),
            options: {
                formatter: formatterValueNoUp,
            },
        },
        onUpload: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../common/components/script-input.vue"),
        },
        onDelete: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../common/components/script-input.vue"),
        },
    },
};
